import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	statusInOpsgenieNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.status-table.status-in-opsgenie-non-final',
		defaultMessage: 'Status in Opsgenie',
		description: 'Transition home incidents step table status in Opsgenie head',
	},
	statusInJiraNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.status-table.status-in-jira-non-final',
		defaultMessage: 'Status in Jira',
		description: 'Transition home incidents step table status in Jira head',
	},
	openNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.status-table.open-non-final',
		defaultMessage: 'Open',
		description: 'Transition home incidents step status table open status',
	},
	resolveNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.status-table.resolve-non-final',
		defaultMessage: 'Resolve',
		description: 'Transition home incidents step status table resolve status',
	},
	closeNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.status-table.close-non-final',
		defaultMessage: 'Close',
		description: 'Transition home incidents step status table close status',
	},
	deleteNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.status-table.delete-non-final',
		defaultMessage: 'Delete',
		description: 'Transition home incidents step status table delete status',
	},
	pendingNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.status-table.pending-non-final',
		defaultMessage: 'Pending',
		description: 'Transition home incidents step status table pending status',
	},
	investigateNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.status-table.investigate-non-final',
		defaultMessage: 'Investigate',
		description: 'Transition home incidents step status table investigate status',
	},
	cancelNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.status-table.cancel-non-final',
		defaultMessage: 'Cancel',
		description: 'Transition home incidents step status table cancel status',
	},
	workInProgressNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.status-table.work-in-progress-non-final',
		defaultMessage: 'Work In Progress',
		description: 'Transition home incidents step status table work in progress status',
	},
	canceledNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.status-table.canceled-non-final',
		defaultMessage: 'Canceled',
		description: 'Transition home incidents step status table cancelled status',
	},
	completedNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.status-table.completed-non-final',
		defaultMessage: 'Completed',
		description: 'Transition home incidents step status table completed status',
	},
});
